module.exports = __webpack_public_path__ + "img/plus-1.bf2e92ff.webp";